import * as React from 'react';

import { ITargetCheckProps } from './types';

import { useSettings } from './useSettings';
import { useRunCheck } from './useRunCheck';
import { Icons, Button, Checkbox, DateInput, TooltipIcon } from '..';

const today = new Date();

const TargetCheck = ({ id }: ITargetCheckProps) => {
  const { settings, actions } = useSettings(id);
  const { isRunning, runCheck, runOutcome } = useRunCheck(id);

  return (
    <div className="flex items-center relative">
      <div className="button-group flex">
        <Button
          primary={true}
          size="small"
          background="grey"
          onClick={runCheck}
          loading={isRunning}
          loadingLabel="Running check"
        >
          Target check
        </Button>
        <Button
          icon={true}
          primary={true}
          size="small"
          background="grey"
          onClick={actions.toggleOpen}
          loading={settings.isFetching}
          disabled={settings.isFetching}
        >
          <Icons.Edit size={20} />
        </Button>
      </div>
      {runOutcome.displayMessage && (
        <TooltipIcon
          className="ml-2"
          type={runOutcome.status === 'Success' ? 'success' : 'warning'}
          width="w-64"
          text={runOutcome.displayMessage}
        />
      )}
      {settings.isOpen && (
        <div className="tooltip tooltip--bottom absolute z-30 w-64 bg-white shadow-md border border-grey-dark text-left py-3 px-3">
          <Checkbox
            className="mb-4"
            secondary={true}
            name="isActive"
            checked={settings.isActive}
            onChange={actions.toggleActive}
          >
            Check daily
          </Checkbox>
          <div className={settings.isActive ? '' : 'opacity-50'}>
            <div className="flex items-center mb-3">
              <span className="w-24">From</span>
              <DateInput
                className="flex-1"
                small={true}
                secondary={true}
                selected={settings.dateFrom || new Date()}
                onChange={actions.setDate('DATE_FROM')}
                minDate={today}
                disabled={!settings.isActive}
              />
            </div>
            <div className="flex items-center mb-4">
              <span className="w-24">To</span>
              <DateInput
                className="flex-1"
                small={true}
                secondary={true}
                selected={
                  settings.dateTo < settings.dateFrom
                    ? settings.dateFrom
                    : settings.dateTo
                }
                onChange={actions.setDate('DATE_TO')}
                minDate={settings.dateFrom || undefined}
                disabled={!settings.isActive}
              />
            </div>
          </div>
          <Button
            size="small"
            onClick={actions.saveSettings}
            loading={settings.isSaving}
            loadingLabel="Saving"
          >
            Save
          </Button>
          {settings.savingError && (
            <p className="inline ml-3 text-red">Error, try again.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default TargetCheck;



// WEBPACK FOOTER //
// ./src/components/TargetCheck/TargetCheck.tsx